



































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class DeletedMessageModal extends Vue {
  // Props

  @Prop({ required: true })
  public message!: any;

  // Computed

  public get messageFieldLabel() {
    return this.message.isInternal
      ? this.$t("_.deleted_note")
      : this.$t("_.deleted_message");
  }

  public get messageFieldType() {
    return this.message.isInternal ? "is-caution" : "is-grey";
  }
}
